module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_46-96c97d457261b7d5026caed71691867a.png";